var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanPrice03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5677 33.6464L42.577 33.6413H42.5589L31.9326 27.8833L21.2887 22.1152L10.6443 27.8833L0.0180826 33.6413H0L0.00925157 33.6464L0 33.6515H0.0180826L10.6443 39.4094L21.2887 45.1775L31.9326 39.4094L42.5589 33.6515H42.577L42.5677 33.6464Z",
    fill: "#DCD8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5677 11.5312L42.577 11.5265H42.5589L31.9326 5.76811L21.2887 0L10.6443 5.76811L0.0180826 11.5265H0L0.00925157 11.5312L0 11.5362H0.0180826L10.6443 17.2946L21.2887 23.0627L31.9326 17.2946L42.5589 11.5362H42.577L42.5677 11.5312Z",
    fill: "#7539FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0180664 11.0625V34.1151L21.2887 22.589L0.0180664 11.0625Z",
    fill: "#B8B1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5588 11.0625V34.1151L21.2886 22.589L42.5588 11.0625Z",
    fill: "#B8B1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanPrice03);
export default __webpack_public_path__ + "static/media/plan-price-03.d641cc1dc985e60f656bf9837ed53406.svg";
export { ForwardRef as ReactComponent };